module.exports = __webpack_public_path__ + "49856ceb4c1641103e481a36c240fc7d.svg";